module.exports = __webpack_public_path__ + "img/preview-video.9874d901.png";